import { Modal, ModalProps, useModals, Button, Radio, Stack, Text } from "@skailer-com/uikit";
import { useGoalDelete } from "@/queries/goals.query.ts";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface GoalConfirmationDeleteWithSubGoalsModalProps extends ModalProps {
  goalId: number;
  onDeleted?: () => void;
}

export function GoalConfirmationDeleteWithSubGoalsModal({
  goalId,
  onDeleted,
  ...props
}: GoalConfirmationDeleteWithSubGoalsModalProps) {
  const { id } = props;
  const { close } = useModals();
  const { t } = useTranslation();
  const [behavior, setBehavior] = useState<"move" | "delete">("move");
  const goalDeleteMutation = useGoalDelete();

  const handleDelete = async () => {
    await goalDeleteMutation.mutateAsync({ id: goalId, behavior });
    close(id);
    onDeleted?.();
  };

  return (
    <Modal
      title={t("goals:delete_goal")}
      withCloser
      closeByEscEnabled
      actions={
        <Stack gap={"smd"} direction={"horizontal"} justify={"between"}>
          <Button
            onClick={handleDelete}
            isLoading={goalDeleteMutation.isPending}
            size={"lg"}
            className={"w-full"}
          >
            {t("goals:delete_goal")}
          </Button>
          <Button
            onClick={() => {
              close(id);
            }}
            variant={"secondary"}
            size={"lg"}
            className={"w-full"}
          >
            {t("common:cancel")}
          </Button>
        </Stack>
      }
      {...props}
    >
      <Stack gap="md">
        <Text>{t("goals:delete_goal_with_subgoals_question")}</Text>
        <Stack gap="sm">
          <Radio
            value="move"
            checked={behavior === "move"}
            onChange={() => setBehavior("move")}
            title={t("goals:subgoals_move_to_parent")}
          />
          <Radio
            value="delete"
            checked={behavior === "delete"}
            onChange={() => setBehavior("delete")}
            title={t("goals:subgoals_delete_all")}
          />
        </Stack>
      </Stack>
    </Modal>
  );
}
